var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer--payment"},_vm._l((_vm.paymentsByStore),function(ref){
var name = ref.name;
var size = ref.size;
var img = ref.img;
return _c('span',{key:name},[_c('router-link',{attrs:{"to":_vm.localizedRoute('/zahlungsarten')}},[(img)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(img),expression:"img"}],class:size,attrs:{"alt":name,"width":"60","height":"35"}}):_vm._e(),_vm._v(" "),(!img)?[_vm._v(_vm._s(name))]:_vm._e()],2)],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }